export enum CheckStatus {
	CREATED = 'created',
	PARTIALLY_PAID = 'partially_paid',
	FINISHED = 'finished',
}
